// extracted by mini-css-extract-plugin
export default {"carttoon_info":"UploadCartoonInput_carttoon_info__VmztG","height_100":"UploadCartoonInput_height_100__Hq4al","description_input":"UploadCartoonInput_description_input__9deQw"};